import { render } from "./create-new-user.vue?vue&type=template&id=427de684&scoped=true"
import script from "./create-new-user.vue?vue&type=script&lang=js"
export * from "./create-new-user.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./create-new-user.vue?vue&type=style&index=1&id=427de684&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427de684"]])

export default __exports__